import {Button, ButtonProps, useMediaQuery} from "@chakra-ui/react";
import React from "react";

const APIconButton = ({ children, sx, ...others }: ButtonProps) => {
  const [isLargeScreen] = useMediaQuery("(min-width: 764px)");
  return (
    <Button
      {...others}
      sx={{
        bg: "#ffffff",
        color: "black",
        boxShadow: "0px 5px 0 0 #e5e2da",
        padding: isLargeScreen ? "0px 12px" : "0px 9px",
        width: isLargeScreen ? "56px" : "45px",
        height: isLargeScreen ? "54px" : "43px",
        borderRadius: isLargeScreen ? "18px" : "15px",
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export default APIconButton;
